export default "__VITE_ASSET__HYVo9w6$__"